module.exports = __webpack_public_path__ + "img/voiture-base.30d74086.png";